import React from 'react';
import { makeStyles, Paper, Typography, Grid } from '@material-ui/core';

const useStyles = makeStyles({
	root: {
		padding: 15,
		display: ({ flex }) => flex && 'flex',
		flexWrap: 'wrap',
		height: '100%',
		overflow: 'auto',
		// maxHeight: ({ header }) =>
		// 	header ? 'calc(100vh - 245px)' : 'calc(100vh - 200px)',
		// minHeight: ({ header }) => (header ? 'calc(100% - 300px)' : 'calc(100% - 250px)'),
		// '@media (max-width: 768px)': {
		// 	maxHeight: ({ header }) =>
		// 		header ? 'calc(100% - 210px)' : 'calc(100% - 160px)',
		// },

		// '@media (max-width: 1201px)': {
		// 	maxHeight: ({ header }) =>
		// 		header ? 'calc(100% - 180px)' : 'calc(100% - 130px)',
		// },
		// '@media (max-height: 800px)': {
		// 	maxHeight: ({ header }) =>
		// 		header ? 'calc(100% - 180px)' : 'calc(100% - 30px)',
		// },
	},
	header: {
		display: 'flex',
		justifyContent: 'flex-start',
		marginBottom: 10,
		flexWrap: 'wrap',
		overflowX: 'auto',
	},
	title: {
		fontSize: 21,
		marginBottom: 15,
	},
	container: {
		margin: 0,
		width: '100%',
	},
});

const PageLayout = ({ children, header, title, flex, minHeight, className, height }) => {
	const classes = useStyles({ flex, minHeight, height, header });
	return (
		<Paper
			className={`${classes.root} ${className}`}
			elevation={0}
			variant="outlined"
		>
			<Grid container className={classes.container} spacing={2}>
				{title && (
					<Grid item md={12}>
						<Typography variant="h6" className={classes.title}>
							{title}
						</Typography>
					</Grid>
				)}
				{header && (
					<Grid item md={12}>
						<div className={classes.header}>{header}</div>
					</Grid>
				)}
			</Grid>
			{children}
		</Paper>
	);
};

export default PageLayout;
